import { GlobalState } from '../../../store/global';
import { createSelector } from '@ngrx/store';
import { LocationComparisonLocation } from '../../../models/review-insights-models/location-comparison-response-entry';
import { SharedFilterNamesEnum } from '../../../models/responding-dashboards-filter-models';
import { ImplementedInsightsFilterNames } from '../../../models/review-insights-models/review-insights-filter';
import { MapLocationInterface } from '../../../models/review-insights-models/map-location';

// feature state
export const selectInsightsFeatureState = (state: GlobalState) => state.reviewInsights;

// raw BE response
// Individual insights depending on insights method used + filters
export const selectRating = createSelector(selectInsightsFeatureState, state => state.rating);
export const selectReviewNumbers = createSelector(selectInsightsFeatureState, state => state.reviewNumbers);
export const selectTopLocations = createSelector(selectInsightsFeatureState, state => state.topLocations);
export const selectLocationComparisonList = createSelector(selectInsightsFeatureState, state => state.locationComparisonList);
export const selectLocationComparisonCount = createSelector(selectInsightsFeatureState, state => state.locationComparisonCount);
export const selectRespondedCommented = createSelector(selectInsightsFeatureState, state => state.respondedCommented);
export const selectResponseTimes = createSelector(selectInsightsFeatureState, state => state.responseTimes);
export const selectResponseTimesOverview = createSelector(selectInsightsFeatureState, state => state.responseTimesOverview);
export const selectPostTimes = createSelector(selectInsightsFeatureState, state => state.postTimes);
export const selectPostsPerWeekday = createSelector(selectInsightsFeatureState, state => state.postsPerWeekday);
export const selectMapLocations = createSelector(selectInsightsFeatureState, state => state.mapLocations);

// Filters
export const selectInsightsFilters = createSelector(selectInsightsFeatureState, state => state.filters);
export const selectLocationComparisonTableSettings = createSelector(selectInsightsFeatureState, state => state.locationComparisonTableSettings);
export const selectFiltersForSuccessfulInsightsCalls = createSelector(selectInsightsFeatureState, state => state.filtersForSuccessfulInsightsCalls);

// Location comparison detail

export const selectLocationComparisonLocations = createSelector(selectLocationComparisonList, selectLocationComparisonTableSettings, (list, settings): LocationComparisonLocation[] => {
  return list?.map((location, i) => {
    // since requests have pagination param, first we have to compute current pageOffset -
    // pageIndex * pageSize, then add location index (zero-based) + 1 
    const pageOffset = settings?.pageSize * settings?.pageIndex + i + 1;
    // address 1-liner
    let address = '';

    if (location.addressLine1) {
      address += location.addressLine1 + ', ';
    }
    if (location.postalCode) {
      address += location.postalCode + ' ';
    }
    if (location.city) {
      address += location.city;
    }

    return {
      ...location,
      position: pageOffset,
      address: address,
    };
  });

});

// MAP LOCATIONS

export const selectFilteredMapLocations = createSelector(selectMapLocations, selectInsightsFilters,
    (mapLocations, filters) => {
      if (!mapLocations) {
        return [];
      }

      let filteredMapLocations: MapLocationInterface[] = [...mapLocations];

      ImplementedInsightsFilterNames.forEach((filterName) => {
        filteredMapLocations = filteredMapLocations.filter((mapLocation) => {
          if (filters?.[filterName]?.length) { // filter has value
            return filters[filterName] // check if location[field] is among filter value
                .includes(mapLocation[filterName === SharedFilterNamesEnum.COUNTRY_CODES ?
                    'country' :
                    filterName]);
          } else return true; // no filter value == PASS
        });
      });

      return filteredMapLocations;
    });
